const arrowHeadings = document.querySelectorAll(
	'.wp-block-heading.is-style-arrow'
);
const processedClass = 'wp-block-heading--arrow-word-wrapped';
const lastWordClass = 'wp-block-heading__arrow-last-word';

const getLinkOnlyChild = (heading) => {
	const directLinks = Array.from(heading.children).filter((child) =>
		child.matches('a')
	);

	if (directLinks.length !== 1) {
		return null;
	}

	const link = directLinks[0];
	const hasOnlyLinkAndWhitespace = Array.from(heading.childNodes).every(
		(node) =>
			node === link ||
			(node.nodeType === Node.TEXT_NODE && '' === node.textContent.trim())
	);

	return hasOnlyLinkAndWhitespace ? link : null;
};

const getLastTextNode = (element) => {
	const treeWalker = document.createTreeWalker(
		element,
		NodeFilter.SHOW_TEXT,
		{
			acceptNode(node) {
				if (node.parentElement?.closest(`.${lastWordClass}`)) {
					return NodeFilter.FILTER_REJECT;
				}

				return '' === node.textContent.trim()
					? NodeFilter.FILTER_REJECT
					: NodeFilter.FILTER_ACCEPT;
			},
		}
	);
	let lastTextNode = null;
	let currentTextNode = treeWalker.nextNode();

	while (currentTextNode) {
		lastTextNode = currentTextNode;
		currentTextNode = treeWalker.nextNode();
	}

	return lastTextNode;
};

const wrapLastWord = (heading) => {
	if (heading.classList.contains(processedClass)) {
		return;
	}

	const wrapTarget = getLinkOnlyChild(heading) ?? heading;
	const lastTextNode = getLastTextNode(wrapTarget);
	const textParts = lastTextNode?.textContent.match(/^([\s\S]*?)(\S+)(\s*)$/);

	if (!lastTextNode || !textParts) {
		return;
	}

	const lastWord = document.createElement('span');
	lastWord.classList.add(lastWordClass);
	lastWord.textContent = textParts[2];

	lastTextNode.replaceWith(
		document.createTextNode(textParts[1]),
		lastWord,
		document.createTextNode(textParts[3])
	);

	heading.classList.add(processedClass);
};

if (arrowHeadings.length > 0) {
	arrowHeadings.forEach(wrapLastWord);
}
